import React, { Fragment } from 'react'
import { Route, HashRouter, Redirect, Switch } from 'react-router-dom'
import { Can } from '@app/context/ability-context'
import SVG from 'react-inlinesvg'
import Notice from '@app/components/ui/notifications/Notice'
import _ from 'lodash'
import playIcon from '@icons/play/primary'
import testIcon from '@icons/test/primary'
import InlineSelect from '@app/components/ui/selects/InlineSelect'
import PillsMenu from '@app/components/teachers/PillsMenu'
import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'

const Task = ({ olympiad, card, number, onNavigate}) => {
  return (
    <div
      className="grid__item grid__item--sm"
      onClick={(e) => {
        onNavigate(`/teachers/tasks/${olympiad.id}/${card.id}`);
        AnalyticsManager.emitPageEvent(PageEventsTypes.OlympTasksTryClick);
      }}
      key={card.id}
      style={{ cursor: "pointer" }}
    >
      <div className="grid grid--sm-1 grid--md-3--kv grid--xl-3--kv">
        <div>
          <span className="f--xl f--bold">{ number }.</span>
          <span className="f--xl f--bold ml-gutter-s">{ card.name }</span>
        </div>

        <div className="text-left va-middle">
          <a
            href="javascript:void(0)"
            className="link link--icon-left f--upper"
            style={{ color: '#9965F4'}}>

            <SVG src={playIcon} />
            { I18n.t('landing.try') }
          </a>
        </div>

        <Can I="read" a={card}>
          <div className="text-left va-middle">
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onNavigate(`/teachers/tasks/${olympiad.id}/${card.id}/answer`);
              }}
              className="link link--icon-left f--upper">

              <SVG src={testIcon} />
              { I18n.t('cards.show_answer') }
            </a>
          </div>
        </Can>
      </div>
    </div>
  )
}

const Content = ({ olympiad, cards, onNavigate }) => {
  return (
    <div className="grid mb-gutter-l">
      {
        _.map(cards, (card, index) => {
          return (
            <Task
              key={card.id}
              olympiad={olympiad}
              card={card}
              number={index + 1}
              onNavigate={onNavigate}
            />
          )
        })
      }
    </div>
  )
}

const Tours = (props) => {
  const { olympiad } = props;
  return (
    <div>
      <Can I="read preparatory" of="Statistic">
        <h3 className="mb-gutter-m">
          { I18n.t("landing.preparatory_round") }
        </h3>
        <Content {...props} cards={olympiad.preparatoryCards} />
      </Can>

      <Can I="read trial" of="Statistic">
        <h3 className="mb-gutter-m">
          { I18n.t("landing.trial_round") }
        </h3>
        <Content {...props} cards={olympiad.trialCards} />
      </Can>

      <Can I="read" a="mainCards" passThrough>
        { can => can ? (
            <Fragment>
              <h3 className="mb-gutter-m">
                { I18n.t("landing.main_round") }
              </h3>

              <Content {...props} cards={olympiad.mainCards} />
            </Fragment>
          ) : null
        }
      </Can>
    </div>
  )
}

const Olympiad = (props) => {
  const { olympiads, route } = props;
  if (!olympiads.length) { return null; }

  const { match: { params } } = route;
  const id = params.olympiad_id || olympiads[0].id;
  const olympiad = _.find(olympiads, ['id', id]);

  if (!olympiad) { return null; }

  const handleChange = (option) => {
    route.history.push({ pathname: option.id });
    AnalyticsManager.emitPageEvent(PageEventsTypes.OlympTasksGradeClick);
  }

  return (
    <Fragment>
      <div style={{
        color: 'rgba(9, 21, 38, 0.85)',
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 'bold',
        marginBottom: '16px'
      }}>
        Tasks
      </div>
      <div className="mb-1 grid grid--sm-1 grid--md-2 grid--xl-3">
        <InlineSelect
          autoFocus
          id="olympiadId"
          name="olympiadId"
          value={olympiad}
          onChange={handleChange}
          options={olympiads}
          getOptionLabel={(option) => option.shortName}
          getOptionValue={(option) => option.id}
          tabIndex="1"
          isSearchable={false}
        />
      </div>

      <Can I="read" a="mainCards" passThrough>
        { can => can ? null : (
            <Notice className="mb-gutter-m">
              { I18n.t('olympic_participations.tasks.notification') }
            </Notice>
          )
        }
      </Can>

      <Tours {...props} olympiad={olympiad} />
    </Fragment>
  )
}

const Tasks = ({ global: { olympiads }, route, teacher }) => {
  const handleNavigate = (location) => {
    route.history.push(location)
  }

  return (
    <Fragment>
      <div className="page mt-2">
        <div className="page__inner">
          <HashRouter basename="/">
            <Switch>
              <Route
                exact
                path={["/", "/:olympiad_id"]}
                render={
                  (hashRoute) => (
                    <Olympiad olympiads={olympiads} route={hashRoute} onNavigate={handleNavigate} />
                  )
                }
              />
            </Switch>
          </HashRouter>
        </div>
      </div>
    </Fragment>
  )
}

export default Tasks
